import { Injectable } from '@angular/core';
import { Storage } from '@ionic/storage-angular';
import { Observable, Subject } from 'rxjs';
import { AlertService } from 'src/app/shared/components/alert/alert.service';
import { MoneyOutCategorizeComponent } from 'src/app/shared/components/movements/money-out-categorize/money-out-categorize.component';
import { KycRenewalStatus, Profile } from 'src/app/shared/models/register.models';

// Renovación continua del KYC en Mangopay (FUN-1032): se relanza la verificación de identidad de Mangopay aunque
// la última sesión esté VALIDATED. El back avisa con kycRenewalStatus en el perfil y con el error 139 al operar
export const KYC_RENEWAL_REQUIRED_ERROR = 139;

@Injectable({
  providedIn: 'root',
})
export class KycRenewalService {

  constructor(private alertService: AlertService, private storage: Storage) { }

  // Emite cuando el usuario termina la verificación (Mangopay la confirma después, por webhook)
  openRenewalModal(username: string): Observable<void> {
    const finished = new Subject<void>();
    const params = { user: { username }, kycRenewal: true };
    this.alertService.showModal(MoneyOutCategorizeComponent, params, '', '', true).subscribe((modal: any) => {
      modal.getChildComponent().subscribe((componentRef: MoneyOutCategorizeComponent) => {
        componentRef.continueEvent.subscribe(() => {
          this.alertService.removeModal();
          // Mangopay lo confirma después: mientras, que el banner no vuelva a salir con el perfil guardado
          this.updateStoredStatus('NOT_REQUIRED', null);
          finished.next();
          finished.complete();
        });
      });
      modal.onClose().subscribe();
      modal.activeCross().subscribe();
    });
    return finished.asObservable();
  }

  // El banner se pinta primero con el perfil guardado en el login: se mantiene al día con el del back
  updateStoredStatus(status: KycRenewalStatus, deadline: string) {
    this.storage.get('PROFILE').then((stored: Profile) => {
      if (!stored || (stored.kycRenewalStatus === status && stored.kycRenewalDeadline === deadline)) { return; }
      this.storage.set('PROFILE', { ...stored, kycRenewalStatus: status, kycRenewalDeadline: deadline });
    });
  }

  // yyyy-MM-dd del back a dd/MM/yyyy
  formatDeadline(deadline: string): string {
    if (!deadline) { return ''; }
    const [year, month, day] = deadline.split('-');
    return `${day}/${month}/${year}`;
  }
}
